import React from 'react';
import { Select } from '../common/Form';

const DATE_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'this_week', label: 'This Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_30_days', label: 'Last 30 Days' },
  { value: 'last_90_days', label: 'Last 90 Days' },
  { value: 'this_year', label: 'This Year' },
];

const RESULT_OPTIONS = [
  { value: 'win', label: 'Wins' },
  { value: 'loss', label: 'Losses' },
];

const LINK_OPTIONS = [
  { value: 'true', label: 'Has Link' },
  { value: 'false', label: 'No Link' },
];

/**
 * Game history filter controls: collapsible on small screens, full bar on lg+.
 */
const GameHistoryFilters = ({ hideFilters, filters, uniqueClubs, handleFilterChange, hasActiveFilters }) => {
  if (hideFilters) return null;

  const fields = (
    <>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-text-secondary mb-1">Club</label>
        <Select
          value={filters.clubId || ''}
          onChange={(e) => handleFilterChange('clubId', e.target.value)}
          placeholder="All Clubs"
          options={uniqueClubs.map((club) => ({ value: club.id, label: club.name }))}
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-text-secondary mb-1">Date Range</label>
        <Select
          value={filters.dateRange || ''}
          onChange={(e) => handleFilterChange('dateRange', e.target.value)}
          placeholder="All Dates"
          options={DATE_RANGE_OPTIONS}
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-text-secondary mb-1">Result</label>
        <Select
          value={filters.result || ''}
          onChange={(e) => handleFilterChange('result', e.target.value)}
          placeholder="All Results"
          options={RESULT_OPTIONS}
        />
      </div>
      <div>
        <label className="block text-xs sm:text-sm font-medium text-text-secondary mb-1">Has Link</label>
        <Select
          value={filters.hasLink === null ? '' : filters.hasLink ? 'true' : 'false'}
          onChange={(e) =>
            handleFilterChange('hasLink', e.target.value === '' ? null : e.target.value === 'true')
          }
          placeholder="All Games"
          options={LINK_OPTIONS}
        />
      </div>
    </>
  );

  return (
    <>
      <details className="mb-4 rounded-lg border border-border bg-surface-subtle lg:hidden">
        <summary className="cursor-pointer select-none px-3 py-2.5 text-sm font-medium text-text-primary list-none [&::-webkit-details-marker]:hidden flex items-center justify-between gap-2">
          <span>Filters</span>
          {hasActiveFilters ? (
            <span className="text-xs font-normal text-primary">Active</span>
          ) : (
            <span className="text-xs font-normal text-text-muted">Tap to expand</span>
          )}
        </summary>
        <div className="grid grid-cols-2 gap-2 border-t border-border px-3 py-3">{fields}</div>
      </details>
      <div className="mb-4 hidden gap-4 rounded-lg border border-border bg-surface-subtle p-4 lg:grid lg:grid-cols-4">
        {fields}
      </div>
    </>
  );
};

export default GameHistoryFilters;
